@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.TestConfigTagBadge {

  @extend %font-family-primary;

  font-size: $font-size-small;
  font-weight: $font-weight-semibold;
  background: $theme-badge-tag-background-color;
  color: $theme-test-case-badge-text;
  padding: 2px 3px;
  border-radius: 4px;
  align-items: center;
  line-height: 16px;
  display: inline-block;

  // trancate text
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 4px;
}